import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common/common.service';
import { DirtyCheck } from 'src/app/constants/message-constant';

@Component({
  selector: 'app-dirtycheck-dialogbox',
  templateUrl: './dirtycheck-dialogbox.component.html',
  styleUrls: ['./dirtycheck-dialogbox.component.scss']
})

export class DirtycheckDialogboxComponent {
  constructor(public activeModal: NgbActiveModal,public ModalService: NgbModal, private active: NgbModal, private common: CommonService) { }
  title = DirtyCheck.TITLE;
  message = DirtyCheck.MESSAGE;
  isFromReturnVal: boolean = false;
  QuestionSetForm!: FormGroup;
  CollageForm!: FormGroup;
  CollegeBatchForm!: FormGroup;
  UserForm!:FormGroup;
  CompanyForm!:FormGroup;
  StudentForm!:FormGroup;
  ParentTechnologyForm !: FormGroup;
  ChildTechnologyForm !: FormGroup;


  closeModal() {
    this.activeModal.close();
  }

  reload() {
    this.common.isSystemAlert = true;
    this.activeModal.close();
    this.ModalService.dismissAll();
    if (this.QuestionSetForm) {
      this.QuestionSetForm.reset();
    }
    else if (this.CollageForm) {
      this.CollageForm.reset();
    }
    else if (this.CollegeBatchForm) {
      this.CollegeBatchForm.reset();
    }
    else if(this.UserForm)
    {
      this.UserForm.reset();
    }
    else if(this.CompanyForm)
    {
      this.CompanyForm.reset();
    }
    else if(this.StudentForm){
      this.StudentForm.reset();
    }
    else if(this.ParentTechnologyForm){
      this.ParentTechnologyForm.reset();
    }
    else if(this.ChildTechnologyForm){
      this.ChildTechnologyForm.reset();
    }
    else {
      const baseHref = window.location.origin; // Get the base URL
      const url = new URL(this.common.href, baseHref);
      window.location.href = url.pathname;
    }
  }
}
